import styled from "styled-components";

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  gap: 10px;
  & .step-container:last-child {
    .separator {
      display: none;
    }
  }
`;
export const StepContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StepSymbol = styled.div<{ active?: boolean }>`
  width: 26px;
  height: 26px;
  background: ${({ active }) => (active ? "var(--main-color)" : "#171C1E")};
  border-radius: 50%;
  color: ${({ active }) => (active ? "#fff" : "#979CA6")};
  font-weight: 600;
  text-align: center;
  line-height: 26px;
  font-size: 14px;
`;
export const StepText = styled.div<{ active?: boolean }>`
  color: ${({ active }) => (active ? "#D9DFE0" : "#979CA6")};
  font-weight: ${({ active }) => (active ? "600" : "400")};
  font-size: 14px;
  margin: 0 10px 0 6px;
  width: auto;
  &.abroad-style {
    width: 120px;
  }
`;
export const StepSeparator = styled.div<{ active?: boolean }>`
  width: 120px;
  height: 2px;
  background: ${({ active }) => (active ? "var(--main-color)" : "#A4B5BB")};
`;
